module.exports = __webpack_public_path__ + "static/img/promotion1.d140caec.png";